module.exports = __webpack_public_path__ + "static/media/modrykonik.36bd8a10.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/modrykonik.png
// module id = 478
// module chunks = 0